// Arriving from a shared link: "/?s=share" (Share Re:Vault) or "/?s=invite#invite=CODE" (a Study
// Hall room invite). The visitor counter in the page's <head> has already read `s` for the day's
// totals, so both parameters come out of the address at once: a reload or a copied address doesn't
// count twice or carry the code around. An invite opens Study Hall, which redeems the code after
// sign-in (the code waits in this tab's sessionStorage).
import { inviteFrom, withoutArrival } from "../shared/share-link.js";

export const INVITE_KEY = "revault:hall:invite";

export function takeArrival(openHall) {
	let search = "", hash = "";
	try { search = location.search; hash = location.hash; } catch { return false; }
	// the inline head script may have taken the code out of the address already
	try { if (!hash && typeof window.__rvInviteHash === "string") hash = window.__rvInviteHash; } catch { /* no stash */ }
	if (!/[?&]s=/.test(search) && !/^#invite=/i.test(hash)) return false;
	const code = inviteFrom(hash);
	try { delete window.__rvInviteHash; } catch { /* already gone */ }
	try { history.replaceState(null, "", withoutArrival(location)); } catch { /* keep the address */ }
	if (!code) return false;
	try { sessionStorage.setItem(INVITE_KEY, code); } catch { /* Study Hall just opens without the invite */ }
	openHall();
	return true;
}
